import { call, put, select, takeLatest} from "redux-saga/effects";
import { PROYECT, api_put } from "services/api";

const SEND_CHANGE_PASSWORD = "SEND_CHANGE_PASSWORD";
const SUCCESS_CHANGE_PASSWORD = "SUCCESS_CHANGE_PASSWORD";
const ERROR_CHANGE_PASSWORD = "ERROR_CHANGE_PASSWORD";
const CLEAR_ERROR_CHANGE_PASSWORD = "CLEAR_ERROR_CHANGE_PASSWORD";

const INITIAL_STATE = {
  isLoading: false,
  error: false,
  errorMessage: "",
  message: "",
};

const changePasswordReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SEND_CHANGE_PASSWORD:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SUCCESS_CHANGE_PASSWORD:
      return {
        ...state,
        isLoading: false,
        message: payload,
      };
    case ERROR_CHANGE_PASSWORD:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_ERROR_CHANGE_PASSWORD:
      return {
        ...state,
        error: false,
        errorMessage: "",
        message: "",
      };
    default:
      return state;
  }
};

function sendChangePassword(id, body) {
  return { type: SEND_CHANGE_PASSWORD, id, body };
}
function clearError() {
  return { type: CLEAR_ERROR_CHANGE_PASSWORD };
}

function* sendForm(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const { id, body } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/users/${id}/password`;
  try {
    yield call(api_put, url, body, auth);
    yield put({
      type: SUCCESS_CHANGE_PASSWORD,
      payload: "Guardado con éxito",
    });
  } catch (message) {
    yield put({
      type: ERROR_CHANGE_PASSWORD,
      payload: {
        message,
      },
    });
  }
}

function* changePasswordSaga() {
  yield takeLatest(SEND_CHANGE_PASSWORD, sendForm);
}

export {
  changePasswordSaga,
  changePasswordReducer,
  sendChangePassword,
  clearError,
};
